import http from "@/http/axios";
import { appModule } from "@/store/modules/app";

export async function getDevicesList() {
  const result = await http.get("/device/summary");
  if (result) {
    if (result.data.status === "Success") {
      return result.data.data.data;
    } else {
      appModule.sendErrorNotice("取得Device統計列表失敗");
    }
  } else {
    appModule.sendErrorNotice("取得Device統計列表失敗");
  }
}